import { Asset } from '../../../assets/dto/Asset';

export interface AssetWithSubcategory extends Omit<Asset, 'subcategory'> {
  subcategory: string;
}

export function isAssetWithSubcategory(asset: Asset): asset is AssetWithSubcategory {
  return !!asset.subcategory;
}
